<template>
  <div class="pl-4 pr-4">
    <div>
      <div class="w-full">
        <SmartInput
          class="mt-4 title"
          label="Nome do ponto crítico"
          placeholder="Ex: Reforma"
          v-model="name"
          name="name"
          :error="errors.first('name')"
          v-validate="'required'"
        />
        <SmartRow class="flex flex-col">
          <div class="ml-2 mt-4">
            Regra
          </div>
          <div>
            <SmartP>
              Baseada no período ou livre.
            </SmartP>
          </div>
          <span class="p-absolute absolute">Status</span>
          <div class="flex align-center absolute box-switch">
            <p v-if="status">Ativo</p>
            <p v-else>Inativo</p>
            <v-switch
              color="default"
              :value="status"
              v-model="status"
              @change="alterSwitchFromNullToFalse(status)"
              class="ml-2 cursor-pointer"
            />
          </div>
          <div class="flex flex-row mt-3 ml-2">
            <v-radio-group
              class="m-0" v-model="rule"
              :mandatory="false" row
            >
              <v-radio label="Livre" checked value="free"/>
              <v-radio label="Período" value="period" :checked="true"/>
            </v-radio-group>
          </div>
          <div
            style="margin-top: 140px"
            class="absolute weight ml-2"
          >
            <SmartInput
              v-show="rule === 'period'"
              label="Peso"
              type="tel"
              mask="####"
              placeholder="75%"
              v-model="weight"
            />
          </div>
        </SmartRow>
        <div class="absolute flex w-full align-center btn-div" style="bottom: 5vh">
          <div>
            <SmartButton
              id="save"
              class="mr-2"
              :disabled="!formIsValid"
              :loading="isLoading"
              @click="sendCriticPoint(name, weight, rule, status)"
            >
              Salvar
            </SmartButton>
          </div>
        </div>
      </div>
    </div>
    <SmartModal
      v-if="modal"
      v-bind="modal"
      @close="closeModal(modal.type)"
    >
      {{ modal.text }}
    </SmartModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { isEmpty } from 'utils';

const defaultOpts = {
  name: '',
  rule: 'free',
  weight: '',
  status: false
};

export default {
  name: 'InfoCreateOrEdit',
  data() {
    return {
      modal: '',
      radios: '',
      isLoading: false,
      ...defaultOpts
    };
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      listUser: 'user/users',
      userPagination: 'user/pagination'
    }),
    formIsValid() {
      return Object.keys(this.fields).every(this.isValidAndRequired);
    }
  },
  watch: {
    info(info) {
      if (isEmpty(info)) {
        this.clearInfo();
        return;
      }

      this.name = info.name;
      this.rule = info.rule;
      this.weight = info.weight;
      this.status = info.enabled;
    }
  },
  methods: {
    ...mapActions({
      update: 'criticPoint/update',
      create: 'criticPoint/create',
      activatePoint: 'criticPoint/activatePoint',
      fetchCriticPoint: 'criticPoint/fetchCriticPoint'
    }),
    isValidAndRequired(field) {
      return this.fields[field].required ? this.fields[field].valid : true;
    },
    closeModal(type) {
      this.modal = null;
      if (type === 'success') {
        this.$emit('close');
      }
    },
    alterSwitchFromNullToFalse(status) {
      if (status == null) {
        this.status = false;
      }
    },
    showSuccessModal(message) {
      this.modal = {
        type: 'success',
        title: 'Tudo Certo!',
        icon: 'accepted',
        buttonText: 'Ok',
        text: message
      };
    },
    showErrorModal(message) {
      this.modal = {
        type: 'warning',
        title: message.title,
        icon: 'alert',
        buttonText: 'Ok, vou tentar novamente',
        text: message.text
      };
    },
    async  sendCriticPoint(name, weight, rule, status) {
      this.isLoading = true;
      if (this.info.id) {
        const { id } = this.info;
        const payload = {
          name,
          weight,
          rule,
          enabled: status,
          id
        };
        try {
          await this.update({ payload });
          this.fetchCriticPoint();
          this.isLoading = false;
          const message = 'Ponto crítico atualizado com sucesso';
          this.showSuccessModal(message);
        } catch (err) {
          if (err.data.message === 'O campo weight é obrigatório quando rule é period.') {
            const message = { title: 'Campo obrigatório', text: 'O campo peso é obrigatório quando a regra é do tipo periodo' };
            this.showErrorModal(message);
            this.isLoading = false;
          } else {
            const message = { title: 'Houve um erro interno', text: 'Houve um erro no servidor tente novamente' };
            this.showErrorModal(message);
          }
        }
      } else {
        this.createPoint(name, weight, rule, status);
      }
    },
    async  createPoint(name, weight, rule, status) {
      this.isLoading = true;
      this.disabled = false;
      const payload = {
        name,
        weight,
        rule,
        enabled: status
      };
      try {
        await this.create({ payload });
        this.fetchCriticPoint();
        this.isLoading = false;
        const message = 'Ponto crítico cadastrado com sucesso.';
        this.showSuccessModal(message);
      } catch (err) {
        if (err.data.message === 'O campo weight é obrigatório quando rule é period.') {
          const message = { title: 'Campo obrigatório', text: 'O campo peso é obrigatório quando a regra é do tipo periodo' };
          this.showErrorModal(message);
          this.isLoading = false;
        } else {
          const message = { title: 'Houve um erro interno', text: 'Houve um erro no servidor tente novamente' };
          this.showErrorModal(message);
        }
      }
    },
    async clearInfo() {
      this.name = defaultOpts.name;
      this.weight = defaultOpts.weight;
      this.status = defaultOpts.status;
      this.rule = defaultOpts.rule;
      await this.$nextTick();
      this.errors.clear();
    }
  }
};
</script>

<style lang="scss">

.v-input--selection-controls .v-input__control {
  width: 100%;
}
.v-input--radio-group__input {
  .v-radio {
    &:first-child {
      width: 35%;
    }
  }
}
.weight {width: 120px}

.flex.btn-div {
  justify-content: flex-end;
  right: 20px;
  margin-top: 65%;
}
.smart-label {
  opacity: 0.38;
}

.box-switch {
  left: 80%;
  top: 53%;
  z-index: 1;
}

.p-absolute {
  left: 80%;
  top: 50%;
}

.smart-input.rounded.w-full {
  border-radius: 6px;
}
</style>
